import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { loginModel } from '../models/auth/login.model';

// auth
import authForm from './auth/auth.model.form.reducer';
import auth from './auth/auth.model.reducer';
// core
import device from './core/device.model.reducer';
import cost from './core/cost.model.reducer';
import control from './core/control.model.reducer';
import alert from './core/alert.model.reducer';
import alertReducer from './core/alert.reducer';
import costReducer from './core/cost.reducer';
import home from './core/home.model.reducer';
//service
import common from './service/common.reducer';
import settings from './service/settings.reducer';
import error from './service/errror.reducer';
import modal from './service/modal.reducer';
import weather from './service/weather.model.reducer';

const appReducer = combineReducers({
    auth,
    cost,
    device,
    control,
    alert,
    common,
    authForm,
    settings,
    error,
    alertReducer,
    costReducer,
    home,
    modal,
    weather,
    routing: routerReducer
});

const rootReducer = (state, action) => {
    if (action.type === loginModel.TYPE_CLEAR) {
        state = undefined;
    }

    return appReducer(state, action);
};

export default rootReducer;


// WEBPACK FOOTER //
// ./~/pluton-core/lib/reducers/root.reducer.js